import { render, staticRenderFns } from "./SiteHeader.vue?vue&type=template&id=77da1ff6&scoped=true&"
import script from "./SiteHeader.vue?vue&type=script&lang=js&"
export * from "./SiteHeader.vue?vue&type=script&lang=js&"
import style0 from "./SiteHeader.vue?vue&type=style&index=0&id=77da1ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77da1ff6",
  null
  
)

export default component.exports